import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import BrandHero from './components/BrandHero';
import BrandServices from './components/BrandServices';
import BrandLocations from './components/BrandLocations';
import BrandProcess from './components/BrandProcess';
import BrandCTA from './components/BrandCTA';

export default function BrandsPage() {
  return (
    <>
      <title>Dragonfruit for Brands — Global Marketing & Live Commerce Agency | Xiaohongshu, TikTok</title>
      <meta name="description" content="Dragonfruit helps brands expand into China and global markets through Xiaohongshu marketing, live commerce, and content strategy. Offices in Seoul, Shanghai, Tokyo, Bangkok, and LA." />
      <main className="min-h-screen bg-background-50">
        <Navbar />
        <BrandHero />
        <BrandServices />
        <BrandLocations />
        <BrandProcess />
        <BrandCTA />
        <Footer />
      </main>
    </>
  );
}